module.exports = __webpack_public_path__ + "static/img/rd-pawnshop-icon.986038bd.png";